import { t } from 'i18next';
import CustomButtonColor from '../../Components/custom-button/CustomButtonColor';
import './CardValue.css';
import { nextStep } from '../../Services/api-service';
import { isNullOrEmpty, removeDotFromStringMoney } from '../../Services/service';
import { warning } from "../../Components/custom-toast/CustomToast.js";
function CardValueProductWidget ({id, objectDto, selected, setObjectDto, setIsLoading}) {
    function handleClick () {
        setIsLoading(true);
        if(objectDto.promotionCode !== selected.promotionCode){
            warning(t("promotioncodenotmatch"));
            setIsLoading(false);
            return;
        }
        var db = {
            ...objectDto, 
            productId: selected.productId, 
            productName: selected.productName, 
            description: selected.description,
            productCode: selected.productCode,
            discountRate: selected.discountRate,
            maleRate: selected.maleRate,
            femaleRate: selected.femaleRate,
            clientFlag: selected.clientFlag,  
            frequency: selected.frequency, 
            policyTerm: selected.policyTerm,
            premiumFemale: selected.premiumFemale,
            premiumMale: selected.premiumMale,
            premium: objectDto.gender === 0 ? selected.premiumMale : selected.premiumFemale,
            premiumOrigin: objectDto.gender === 0 ? selected.premiumOriginMale : selected.premiumOriginFemale,
            strSumAssured: selected.strSumAssured,
            sumAssured: selected.sumAssured
        };
        nextStep(db, setObjectDto, setIsLoading);
    }
    // fix money, if remove "dong" then remove this func
    const splitSpaceMoney = (money) => {
        if(isNullOrEmpty(money)) return "";
        return money.split(" ")[0];
    }
    return (
        <div className="card-value-product-new" key={id}>
            <div className="title-card-value-new product-title-card">
                <label>{selected.productName}</label>
            </div>
            <p className='title-money-policy-new product-title-card-label-new'>{t("moneypolicy")}</p>
            <div className="money-card-value-new product-title-card">
                <label>{splitSpaceMoney(selected.strSumAssured)}</label>
            </div>
            <div className="money-card-value-new product-title-card">
                <label>{t("vnd")}</label>
            </div>
            <div className='product-title-card-fee-label-new'>
                <p className='title-money-policy-new product-title-card-label'>{t("feepolicy")}</p>
                {/* <p className='title-money-policy-new product-title-card-label money-discount'>{t("discount20")}</p> */}
                <p className='title-money-policy-new product-title-card-label money-discount'>{t("discount") + " " + objectDto.discount + t("percent")}</p>
            </div>
            {/* <div className="total-card-value product-desc-card"> */}
            {/* <p className='title-money-origin-policy product-title-card-label'>{t("feeorigin")}</p> */}
            <div className="total-card-value-new product-title-card">
                <label>{(objectDto.gender === 0 ? removeDotFromStringMoney(selected.premiumOriginMale) : removeDotFromStringMoney(selected.premiumOriginFemale)) + " " + t("vnd") + t("peryear")}</label>
            </div>
            {/* <p className='title-money-discount-policy product-title-card-label'>{t("feediscount")}</p> */}
            <div className="total-discount-card-value-new product-title-card">
                <label className='home-title-product'>{(objectDto.gender === 0 ? removeDotFromStringMoney(selected.premiumMale) : removeDotFromStringMoney(selected.premiumFemale))}</label>
            </div>
            <div className="total-discount-card-value-new product-title-card-label">
                <label>{t("vnd") + t("peryear")}</label>
            </div>
            <CustomButtonColor bgColor={"#050509"}  color={"#ffffff !important"} title={t("buynow")}  onClick={()=>{handleClick(selected.productId)}}  /> 
        </div>
    )
}
export default CardValueProductWidget;